module.exports = __webpack_public_path__ + "img/3bf8bee.svg";